import type { IconProps } from '../types/IconProps.ts';
export const Radio: IconProps = {
    name: 'Radio',
    children: [
        `<path d="M18 20a9.98 9.98 0 0 0 0-16M6 20A9.98 9.98 0 0 1 6 4" />`,
        `<path d="M8.26 16.69a6 6 0 0 1 0-9.38M15.74 7.3a6 6 0 0 1 0 9.4M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />`,
    ]
};